import { Component, OnInit, Input, NgZone, HostListener } from '@angular/core';
import { MatDialog, MatDialogModule, MatDialogConfig } from '@angular/material/dialog';
import { DataService } from '../data.service';
import { QuestionarySaveComponent } from '../questionary-save/questionary-save.component';
import { QuestionaryExitintentComponent } from '../questionary-exitintent/questionary-exitintent.component';
import { QuestionaryBadgeComponent } from '../questionary-badge/questionary-badge.component';
import { MatSnackBar, MatSnackBarHorizontalPosition,  MatSnackBarVerticalPosition } from '@angular/material/snack-bar';

declare let $: any;

@Component({
    selector: 'app-questionary',
    templateUrl: './questionary.component.html',
    styleUrls: ['./questionary.component.css']
})
export class QuestionaryComponent implements OnInit {
    public arrData = new Array<any>();
    public arrTable = new Array<any>();
    public arrTable1 = new Array<any>();
    public arrTable2 = new Array<any>();
    public arrTable3 = new Array<any>();
    public arrTable4 = new Array<any>();
    public arrTable5 = new Array<any>();
    public arrTable6 = new Array<any>();
    public arrProgress = new Array<any>();
    public arrBadges = new Array<any>();
    public currentpage = 0; //current page
    public progressinpercent = 0; // progress in percent
    public questionaryquestionbadgecode = ""; //questionary question badge code
    public questionaryquestionbadgetitle = ""; //questionary question badge title
    public questionaryquestionbadgemessage = ""; //questionary question badge message
    public showbadge = false; //show badge/achievement
    public maxpages = 1;
    public exitintentdialognotyetshown = true;
    @Input() questionaryid;
    @Input() pagenumber;
    @Input() questionaryanswerhashcode;
    closingclass = '';
    public matrix = new Array<any>();
    errors = '';
    showjavscripterrors = false;

    //badge animation ended: hide badge component
    badgeanimationendevent($event) {
        this.showbadge = false;
    }

    constructor(public dataservice: DataService, public dialog: MatDialog, private ngZone: NgZone, private _snackBar: MatSnackBar) {
    }

    //on init
    ngOnInit() {
        this.loadQuestionary(null, null);
    }

    //load questionary
    loadQuestionary(questionaryform, page) {
        // data
        if (questionaryform) {

            //init errors
            this.errors = '';

            //main content frame height
            $('#mainq').animate({ 'min-height': $(window).height() }, 500);

            //save questionary
            this.dataservice.setElementData(-1, 'QuestionarySet', JSON.stringify(questionaryform.value), '').subscribe((data) => {
                this.questionaryanswerhashcode = data.questionaryanswerhashcode;

                if (data.errors != '') {
                    this.errors = data.errors;
                    this.setPageHeight(200);
                }
                else {
                    //show badge: achievement
                    this.questionaryquestionbadgecode = (parseInt(this.pagenumber) == this.currentpage ? (this.arrProgress[0]["questionaryquestionbadgecode"] == null ? "" : this.arrProgress[0]["questionaryquestionbadgecode"]) : "");
                    this.questionaryquestionbadgetitle = this.arrProgress[0]["questionaryquestionbadgetitle"];
                    this.questionaryquestionbadgemessage = this.arrProgress[0]["questionaryquestionbadgemessage"];
                    this.showbadge = (this.questionaryquestionbadgecode != '');

                    //next page w or wo delay depending on badge
                    setTimeout(() => {
                        //next page
                        this.setPage(page);
                        this.getQuestionaryData();
                    }, (this.showbadge ? 1500 : 0));


                }
            });
        }
        else {
            this.errors = '';

            if (page != null)
                this.setPage(page);

            this.getQuestionaryData();
        }

        //enable exit intent on this page
        this.exitintentdialognotyetshown = true;
    }

    getQuestionaryData() {

        //get element data
        this.dataservice.getElementData(-1, 0, 0, 0, false, 'g2/questionary', (returndata: any) => {
            this.arrData = returndata;
            this.arrTable = returndata.Table;
            this.arrTable1 = returndata.Table1;
            this.arrTable2 = returndata.Table2;
            this.arrTable3 = returndata.Table3;
            this.arrTable4 = returndata.Table4;
            this.arrTable5 = returndata.Table5;
            this.arrTable6 = returndata.Table6;
            this.arrProgress = returndata.Table7;
            this.arrBadges = returndata.Table8;

            //current page, progress in percent and badge data
            this.currentpage = this.arrProgress[0]["currentpage"];
            this.progressinpercent = Math.round(this.arrProgress[0]["progressinpercent"]);
            this.maxpages = this.arrTable[0]["pages"];

            //reload if page not ok
            var reloadbypage = false;
            if (this.arrTable[0].questionaryanswerstatusid != 2) {
                if (parseInt(this.pagenumber) > parseInt(this.arrTable[0]["pages"])) { //set maxpage
                    this.pagenumber = parseInt(this.arrTable[0]["pages"]);
                    reloadbypage = true;
                }
                if (parseInt(this.pagenumber) > parseInt(this.arrProgress[0]["currentpage"])) { //if request page is larger than currentpage: redirect to page
                    this.pagenumber = parseInt(this.arrProgress[0]["currentpage"]);
                    reloadbypage = true;
                }
                if (reloadbypage) this.getQuestionaryData();
            }

            //set history url
            var urllocation = window.location.protocol + '//' + window.location.hostname + ':' + window.location.port + '/' + window.location.pathname.toString().split('/')[1]
                urllocation = urllocation + (this.questionaryanswerhashcode != '' ? '/' + this.questionaryanswerhashcode : '') + (this.arrTable[0].questionaryanswerstatusid == 2 ? '' : '?pagenumber=' + this.pagenumber);
            window.history.pushState({}, null, urllocation);

            //toast on completion: email message with the report (show toast if questionary closed, email present and email not yet sent)
            if (this.arrTable[0].questionaryanswerstatusid == 2 && this.arrTable[0]["questionansweremail"] != '' && this.arrTable[0].questionansweremailsent == 0) {
                this.openSnackBar('Your e-mail message with the report has been sent out.', 'OK');
            }

        }, 'questionaryid=' + this.questionaryid + '&pagenumber=' + this.pagenumber + '&questionaryanswerhashcode=' + this.questionaryanswerhashcode);
    }

    setPage(forward) {
        window.scrollTo(0, 0);

        this.setPageHeight(1000);

        if (forward == 1) {
            this.pagenumber = parseInt(this.pagenumber) + 1;

            this.closingclass = 'trans closing';
            setTimeout(() => { this.closingclass = 'close'; }, 400);
            setTimeout(() => { this.closingclass = 'trans opening'; }, 450);
            setTimeout(() => { this.closingclass = ''; }, 900);
        }
        else {
            this.pagenumber = parseInt(this.pagenumber) - 1;

            this.closingclass = 'trans close';
            setTimeout(() => { this.closingclass = 'closing'; }, 400);
            setTimeout(() => { this.closingclass = 'trans opening'; }, 450);
            setTimeout(() => { this.closingclass = ''; }, 900);
        }
    }

    setPageHeight(time) {
        setTimeout(() => {
            var maxheight = $('.qinner').height() + 30;
            $('#mainq').animate({ 'min-height': maxheight }, 400);
        }, time);
    }

    getMatrix(paramquestionaryquestionid) {
        return this.arrTable6.filter(item => item.questionaryquestionid == paramquestionaryquestionid);
    }

    getMatrixFirst(paramquestionaryquestionid) {
        return this.arrTable6.filter(item => item.questionaryquestionid == paramquestionaryquestionid)[0];
    }

    getMatrixRows(paramquestionaryquestionid, columncount) {
        var arrreturn = new Array<any>();
        var arrfilter = this.arrTable6.filter(item => item.questionaryquestionid == paramquestionaryquestionid);

        for (let i = 0; i < arrfilter.length; i++) {
            if ((i + 1) % columncount == 0) {
                arrreturn.push(arrfilter[i]);
            }
        }

        //set onload value
        for (let i = 0; i < arrreturn.length; i++) {
            let rowvalue = this.getMatrixValue(this.getMatrixRowColumns(arrreturn[i].questionaryquestionid, columncount, i));

            if (arrreturn[i].value == 0 && rowvalue > 0)
                arrreturn[i].value = rowvalue;
            //else
            //    arrreturn[i].value = '';
        }


        return arrreturn;
    }

    getMatrixRowColumns(paramquestionaryquestionid, columncount, matrixrowindex) {
        var arrreturn = new Array<any>();
        var arrfilter = this.arrTable6.filter(item => item.questionaryquestionid == paramquestionaryquestionid);

        matrixrowindex = matrixrowindex + 1;
        var linetop = (columncount * (matrixrowindex - 1)) + 1;
        var linebottom = (columncount * matrixrowindex);

        for (let i = 0; i < arrfilter.length; i++) {
            if (linetop <= (i + 1) && (i + 1) <= linebottom) {
                arrreturn.push(arrfilter[i]);
            }
        }

        //console.log(arrreturn);

        return arrreturn;
    }


    getMatrixValue(columnsarray) {
        let value = 0;
        for (let i = 0; i < columnsarray.length; i++) {
            if (columnsarray[i].valuequestionaryquestionmatrixcolumnid > 0) {
                value = columnsarray[i].questionaryquestionmatrixcolumnid;
            }
        }
        return value;
    }


    getTable4Field(paramquestionaryquestionid) {
        return this.arrTable4.filter(item => item.questionaryquestionid == paramquestionaryquestionid);
    }

    //set slider changed
    public setSliderChanged(event, currentsum, qvalue, questionaryquestionid, questionaryquestionfieldid) {
        if (currentsum > 100) {
            var newvalue = parseInt(event.source.value) - (parseInt(currentsum) - 100);
            if (newvalue < 0) newvalue = 0;
            if (newvalue > 100) newvalue = 100;
            this.arrTable4.filter(item => item.questionaryquestionid == questionaryquestionid && item.questionaryquestionfieldid == questionaryquestionfieldid)[0].value = newvalue;
        }
    }

    //get slider sum
    getSliderSum(array, questionaryquestionid) {
        let value = 0;
        for (let i = 0; i < array.length; i++) {
            if (array[i].value > 0) {
                value += parseInt(array[i].value);
            }
        }

        this.arrTable1.filter(item => item.questionaryquestionid == questionaryquestionid)[0].sum = value;
        return value;
    }

    isInvalid(questionaryform, name) {
        if (questionaryform.form.controls[name])
            return questionaryform.form.controls[name].invalid;
        //else
        //    return false;
    }


    getMatrixName(questionaryquestionid, questionaryquestionmatrixrowid, pagenumber, questionaryquestiontypecode) {
        //console.log(questionaryquestiontypecode);

        return 'matrix_' + questionaryquestionid + '_' + questionaryquestionmatrixrowid + '_' + pagenumber;

    }

    setTableValue(paramquestionaryquestionid, value) {
        if (value > 0) {
            if (this.arrTable1.filter(item => item.questionaryquestionid == paramquestionaryquestionid)[0].value == undefined) {
                this.arrTable1.filter(item => item.questionaryquestionid == paramquestionaryquestionid)[0].value = value;
                console.log(this.arrTable1.filter(item => item.questionaryquestionid == paramquestionaryquestionid)[0]);
            }
        }
    }

    //open snack bar
    openSnackBar(message, action) {
        let openedSnackBarRef = this._snackBar.open(message, action, {
            horizontalPosition: 'center',
            verticalPosition: 'top',
            duration: 4000
        });
    }

    /*open questionary save dialog*/
    openQuestionarySaveDialog(questionaryform) {

        //save questionary before dialog open
        this.dataservice.setElementData(-1, 'QuestionarySet', JSON.stringify(questionaryform.value), '').subscribe((data) => {
            //dialog saved
            //nop
        });

        //dialog config
        const dialogConfig = new MatDialogConfig();
        dialogConfig.disableClose = false;
        dialogConfig.autoFocus = true;
        dialogConfig.width = "90%";
        dialogConfig.maxWidth = "700px";

        //open dialog
        const dialogRef = this.dialog.open(QuestionarySaveComponent, dialogConfig);

        //result
        dialogRef.afterClosed().subscribe(result => {
            if (result.email!= undefined && result.email != '') //result email present
            {
                this.dataservice.setElementData(-1, 'QuestionarySendUrl', JSON.stringify({
                    "email": result.email,
                    "url": window.location.href
                }), '').subscribe((data) => {
                    //toast
                    this.openSnackBar('Your e-mail message has been sent out.', 'OK');
                });
            }
        });
    }

    //move tooltip into view
    tooltipIntoView(event: Event) {
        var tooltip = (event.currentTarget as Element).querySelector("div");
        if (tooltip != null)
        {
            if (tooltip.className == "tooltiptextbottom")
                (event.currentTarget as Element).scrollIntoView({ behavior: 'smooth' });
            if (tooltip.className == "tooltiptexttop")
                tooltip.scrollIntoView({ behavior: 'smooth' });
        }
    }

    //exit intent dialog
    @HostListener('document:mouseout', ['$event'])
    onMouseOut(ev: MouseEvent) {
               const shouldShowExitIntent =
                //!e.toElement &&
                !ev.relatedTarget &&
                ev.clientY < 10;

        if (shouldShowExitIntent && this.exitintentdialognotyetshown && this.arrTable[0].questionaryanswerstatusid != 2 && this.currentpage > 4) {
                //dialog config
                const dialogConfig = new MatDialogConfig();
                dialogConfig.disableClose = false;
                dialogConfig.autoFocus = true;
                dialogConfig.width = "90%";
                dialogConfig.maxWidth = "700px";

                //open dialog
                const dialogRef = this.dialog.open(QuestionaryExitintentComponent, dialogConfig);

                //disable exit intent on this page
                this.exitintentdialognotyetshown = false;
            }
    }
}
